//Returns change amount in dollars and percentage when previous value is passed as an argument
//Example: "123.456" with argument "234.567" returns "— $111.11 (—47.37%)"
import toFixed from "./toFixed";

export default function changeAmount(value, prevValue) {
	let changeUSD;
	let changePercent;
	let changeSign;
	let ret;

	if (parseFloat(value) && parseFloat(prevValue)) {
		changeUSD = value - prevValue;
		changeSign = changeUSD < 0 ? "-" : "";
		changePercent = (value / prevValue - 1) * 100;
		ret = `${changeSign}$${toFixed(
			Math.abs(changeUSD),
			2
		)} (${changeSign}${toFixed(Math.abs(changePercent), 2)}%)`;
	}
	return ret ? ret : "";
}
